import React from 'react';

export function PlaceholderPage({ title }) {
  return (
    <div className="placeholder-page">
      <h1>{title}</h1>
      <p>Page en construction</p>
    </div>
  );
}
